import { OPTIONS } from '.'
import { PERMS } from '@SonarCX/hooks/useAccess'

export const filterRoutes = (
  hasPermission: (perm: string | string[]) => boolean,
  hasAdmin: boolean
) => {
  const copy = { ...OPTIONS }

  if (!hasPermission([PERMS.TasksAdmin, PERMS.TasksOwn, PERMS.TasksAudit])) {
    delete copy.Tasks
  }

  if (!hasPermission(PERMS.IntegrationsAdmin)) {
    delete copy.Integrations
  }

  if (!hasPermission(PERMS.InboxesAdmin)) {
    delete copy.Inboxes
  }

  if (!hasPermission([PERMS.BillingView, PERMS.BillingAdmin])) {
    delete copy['Subscription & Billing']
  }

  if (!hasPermission(PERMS.SettingsAdmin)) {
    delete copy.General
    delete copy['Custom Fields']
    delete copy['External Channels']
  }

  if (!hasPermission(PERMS.TagsAdmin)) {
    delete copy.Tags
  }

  if (!hasAdmin) {
    delete copy['Roles & Permissions']
    delete copy.Users
    delete copy.Teams
  }

  return copy
}
